'use client';

import { createContext } from 'react';
import type { AttachmentUploadContext } from './AttachmentsToolbar.types';

const AttachmentsToolbarContext = createContext<AttachmentUploadContext>({
  attachments: [],
  count: {
    total: 0,
    initializing: 0,
    uploading: 0,
    uploaded: 0,
    failed: 0,
    waiting: 0,
  },
  dispatch: () => {},
});

export const { Provider: AttachmentsToolbarContextProvider } =
  AttachmentsToolbarContext;

export default AttachmentsToolbarContext;
